(function () {
    'use strict';
    $(document).ready(function () {
        const $body = $('body');
        const $header = $('header.header');
        const $sectionTop = $('section.top');
        const $menuOverlay = $('.menu-overlay');

        const scrollTo = (top) => {
            $("html, body").animate({
                scrollTop: top - 60
            }, 1000);
        }

        if (location.pathname === '/' && location.hash) {
            const $hash = $(location.hash);
            if ($hash.length) {
                scrollTo($hash.offset().top);
            }
        }

        $(".js-modal-btn").modalVideo();


        // Smooth scroll to
        $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();

            if (location.pathname !== '/') {
                const href = e.currentTarget.getAttribute('href');
                window.location.href = `/${href}`;
                return;
            }

            const href = $(this).attr('href');
            if (href) {
                scrollTo($(href).offset().top);
                $header.removeClass('open');
                $('.menu-toggle').removeClass('open');
                $menuOverlay.fadeOut();
                $menuOverlay.removeClass('open');
                $('body').removeClass('menu-open');
            }
        });

        $(window).on('scroll', function () {
            const scrollTop = $(window).scrollTop();
            let scrollPoint = 0;
            if ($body.hasClass('home')) {
                scrollPoint = 30;
            } else if ($body.hasClass('single-oferta-pracy')) {
                scrollPoint = $sectionTop.offset().top + $sectionTop.innerHeight() - $header.innerHeight();
            }

            if (scrollTop > scrollPoint) {
                !$header.hasClass('scrolled') && $header.addClass('scrolled');
            } else {
                $header.hasClass('scrolled') && $header.removeClass('scrolled');
            }
        })


        //Clicked outside of element
        window.clickedOutside = function (targetToClose, callback, _excludes = []) {
            const excludes = Array.isArray(_excludes) ? _excludes : [_excludes];
            const $target = $(targetToClose);

            if (typeof callback !== "function") {
                console.error('Callback has to be a function!');
                return null;
            }

            $('body').on('click', function (e) {
                const clickedElement = e.target;
                const isTargetVisible = $target.css('display') !== 'none';
                const isClickedElementExcluded = excludes.some((exclusion) => $(exclusion).is(clickedElement) || !!$(exclusion).has(clickedElement).length);
                const isClickedElementTarget = $target.is(clickedElement);
                const isClickedElementATargetChild = $target.has(clickedElement).length === 0;

                if (
                    isTargetVisible &&
                    !isClickedElementExcluded &&
                    !isClickedElementTarget &&
                    isClickedElementATargetChild
                ) {
                    callback($target, excludes);
                }
            });
        }
    });
}(jQuery));
